import {SERVER_URL, REST_API_URL, STD_HEADERS} from '../settings/base';

const courseStructureUrl = REST_API_URL + "course_structure/";


export const getCourseStructure = (courseID, approved) => {
    let link = REST_API_URL + (approved ? "approve_course_structure/" : "course_structure/");
    return fetch(
        // link  + "course_structure/?course_id=" + courseID,
        link + "?course_id=" + courseID,
        {
            method: 'GET',
            headers: STD_HEADERS,
        }
    )
};


const testUrl = REST_API_URL + "test/" + "get_test/";


export const getTest = (itemPK, everyone) => {
    if (everyone) {
        console.log("checking header");
        STD_HEADERS.Authorization = 'CgjhbvZHeccrbqT,fkDfcDHjn';
    } else {
        console.log("not today")
    }

    console.log("This is header", STD_HEADERS);
    return fetch(
        // link + "test/get_test/?item_pk=" + itemPK,
        testUrl + "?item_pk=" + itemPK,
        {
            method: 'GET',
            headers: STD_HEADERS,

        }
    )
};

export const getPage = link => {
    return fetch(link
        , {
            method: 'GET',
            // mode:'no-cors',
            headers: STD_HEADERS,
        }
    )
};
// export const getPage = link => (
//     fetch(link
//         , {
//             method: 'GET',
//             // headers: STD_HEADERS,
//         }
//     )
// );



// WEBPACK FOOTER //
// ./src/api/get_apis.js